import React from 'react'

const Faq = () => {
  return (
    <div className="w-100">
      <div className="header">
        <h1 className="header-title">Faq ?</h1>
      </div>
      <div className="row w-100 card py-4 px-0">
        <div className="tradeForm position-relative"></div>
      </div>
    </div>
  );
}

export  {Faq}